import { List, Map } from 'immutable';
import Ingredient, { Ingredients } from 'records/Ingredient';
import BaseList from 'records/BaseList';

import {
  INGREDIENTS_ASYNC_ACTION_START,
  INGREDIENTS_ASYNC_ACTION_ERROR,
  INGREDIENTS_ASYNC_UPDATE_ACTION_SUCCESS,
  INGREDIENTS_DRAGGABLE_UPDATE,
  INGREDIENTS_OPTIONS_UPDATE,
  INGREDIENTS_UPDATE_ORDINAL_SUCCESS,
  INGREDIENTS_RESET_STATE,
  INGREDIENTS_UPDATE_ITEM_INTO_LIST,
  INGREDIENTS_UPDATE_ITEMS_UPDATING,
} from 'actions/ingredients';

const initialState = new BaseList({
  loading: false,
  updating: false,
  errorMessage: null,
  options: new Map(),
  data: new List(),
});

const actionsMap = {
  [INGREDIENTS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [INGREDIENTS_UPDATE_ITEMS_UPDATING]: (state, action) => {
    return state.merge({
      updating: action.updating,
    });
  },
  [INGREDIENTS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [INGREDIENTS_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    let newIngredients = Ingredients(action.data);
    newIngredients = Ingredient.sortIngredientsByOrdinal(newIngredients);
    return new BaseList({
      loading: false,
      errorMessage: null,
      data: newIngredients,
    });
  },
  [INGREDIENTS_DRAGGABLE_UPDATE]: (state, action) => {
    let newIngredients = Ingredient.updateIngredientOrdinalsFromIndex(action.data);
    newIngredients = Ingredient.sortIngredientsByOrdinal(newIngredients);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newIngredients,
    });
  },
  [INGREDIENTS_UPDATE_ORDINAL_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [INGREDIENTS_OPTIONS_UPDATE]: (state, action) => {
    return state.merge({
      options: action.options,
    });
  },
  [INGREDIENTS_RESET_STATE]: () => {
    return initialState;
  },
  [INGREDIENTS_UPDATE_ITEM_INTO_LIST]: (state, action) => {
    // will merge the given ingredient into list
    const originalList = state.get('data');
    const index = originalList.findIndex((ingredient) => {
      return ingredient.get('id') === action.data.get('id');
    });
    const newList = originalList.set(index, action.data);
    return state.merge({
      data: newList,
    });
  },
};

export default function ingredients(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
